export default __webpack_public_path__ + "static/media/198.2a269b7e.png";